/**
 * 每隔一段时间执行一次函数
 * @param {Function} action 执行函数
 * @param {Number} time 执行间隔
 */
export function everyTimeDoAction(action, time = 3000) {
  window.setTimeout(() => {
    try {
      action && typeof action === 'function' && action();
    } catch (e) {
      console.log(e);
    }

    everyTimeDoAction(action, time);
  }, time);
}

/**
 * 匹配正则成功，则执行函数
 * @param {String} ua
 * @param {Object} regexp
 * @param {Function} cb
 */
export function match(ua, regexp, cb) {
  if (regexp.test(ua)) {
    cb && typeof cb === 'function' && cb();
  }
}

/**
 * 生成 UUID
 */
export function generateUUID() {
  const len = 36; // 长度为36
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  let r;

  uuid[8] = '-';
  uuid[13] = '-';
  uuid[18] = '-';
  uuid[23] = '-';
  uuid[14] = '4';
  for (i = 0; i < len; i++) {
    if (!uuid[i]) {
      r = 0 | (Math.random() * 16);
      uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
    }
  }
  return uuid.join('');
};

